<template>
  <p class="clearfix mb-0">
    <span class="float-md-left d-block d-md-inline-block mt-25">
      COPYRIGHT  © {{ new Date().getFullYear() != 2021 ? "2021 - " + new Date().getFullYear() : new Date().getFullYear() }}
      <b-link
        class="ml-25"
        href="https://bixware.de"
        target="_blank"
      >Bixware - Kevin Cortellini</b-link>
      <span class="d-none d-sm-inline-block">, All rights Reserved</span>
    </span>

    <span class="ml-5 d-block d-md-inline-block mt-25">
       Mongo-DB:
      <b-badge
          pill
          :variant="storageSizeInBytes < 3e+8 ? 'light-info' : 'light-danger'"
          class="mb-1 ml-1"
      >
        Storage: {{formatBytes(storageSizeInBytes)}}
      </b-badge>
      <b-badge
          pill
          :variant="dataSizeInBytes < 3e+8 ? 'light-info' : 'light-danger'"
          class="mb-1 ml-1"
      >
        Data: {{formatBytes(dataSizeInBytes)}}
      </b-badge>

    </span>

    <span class="float-md-right d-none d-md-block">Hand-crafted &amp; Made with
      <feather-icon
        icon="HeartIcon"
        size="21"
        class="text-danger stroke-current"
      />&ensp; in Leipzig V1.0.1a
    </span>
  </p>
</template>

<script>
import { BBadge, BLink } from 'bootstrap-vue'

export default {
  components: {
    BLink,
    BBadge
  },
  data() {
    return {
      storageSizeInBytes: 0,
      dataSizeInBytes: 0,
    }
  },
  mounted() {
    console.log("Start Mongo Size")
    console.log("Start Mongo Cookie " + this.$cookies.get('jwt'))
    this.$http.get('/mongo/size')
        .then(resp => {
          console.log(resp.data)
          this.storageSizeInBytes = resp.data.storageSizeInBytes
          this.dataSizeInBytes = resp.data.dataSizeInBytes
        })
        .catch(err => {
          console.error(err)
        })
    console.log("finish Mongo Size")

  },
  methods: {
    formatBytes(bytes, decimals = 2) {
      if (bytes === 0) return '0 Byte';

      const k = 1024;
      const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
      const i = Math.floor(Math.log(bytes) / Math.log(k));

      return parseFloat((bytes / Math.pow(k, i)).toFixed(decimals)) + ' ' + sizes[i];
    }
  }
}
</script>
